import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import FixedAssetsTypeModalForm from "../../Forms/FixedAssetsTypeList/FixedAssetsTypeList";

const FixedAssetsTypeModal = (props) => {
  const formName = "FixedAssetsTypeModalForm";
  const { handleHide, show } = props;

  return (
    <BMXModal
      open={show}
      width={"750px"}
      onClose={handleHide}
      header={props.header}
    >
      <FixedAssetsTypeModalForm
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "FixedAssetsTypeModal" })(
  FixedAssetsTypeModal
);
